// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { get } from '@tls/auth';
import { RefObject } from 'react';

function isHTMLImageElement(
  element: HTMLImageElement | RefObject<HTMLImageElement | null>
): element is HTMLImageElement {
  return (element as HTMLImageElement)?.dataset !== undefined;
}

export function loadArrayIntoImageElement(
  array: BlobPart[],
  type: string,
  imageElement: HTMLImageElement | RefObject<HTMLImageElement | null>
) {
  const blob = new Blob(array, { type });
  loadBlobIntoImageElement(blob, imageElement);
}

async function loadBlobIntoImageElement(
  blob: Blob,
  imageElement: HTMLImageElement | RefObject<HTMLImageElement | null>
) {
  const reader = new globalThis.FileReader();

  const element = GetImageElement(imageElement);

  reader.onload = function () {
    const imageDataUrl = reader.result;
    if (!imageDataUrl || imageDataUrl.toString().trim() === 'data:') return;

    element?.setAttribute('src', imageDataUrl.toString());
  };

  if (blob.size === 0) return;
  reader.readAsDataURL(blob);
}

export default async function loadImageIntoElementByUrl(
  url: string,
  imageElement: HTMLImageElement | RefObject<HTMLImageElement | null>
) {
  const response = await get(url, false, false, {
    responseType: 'blob',
  });

  const element = GetImageElement(imageElement);

  const blobResponse = response.data as Blob;
  if (response.status >= 400 || blobResponse?.size === undefined || blobResponse.size === 0) {
    return element?.onerror?.(response.status, url);
  }

  loadBlobIntoImageElement(blobResponse, imageElement);
}

function GetImageElement(imageElement: HTMLImageElement | RefObject<HTMLImageElement | null>) {
  let element: HTMLImageElement | null;
  if (isHTMLImageElement(imageElement)) {
    element = imageElement;
  } else {
    element = imageElement.current;
  }
  return element;
}

export function blobToBase64(blob: Blob) {
  return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
